var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnumLogoShortWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E6F2F8",
  d: "M21.758 14.19a6.44 6.44 0 0 1-2.865-2.424 6.3 6.3 0 0 1-1-3.585c-.002-.828.167-1.648.494-2.41a6.2 6.2 0 0 1 1.41-2.03 6.3 6.3 0 0 1 2.102-1.331 6.4 6.4 0 0 1 2.463-.42c.963 0 1.913.211 2.783.619.869.407 1.635 1 2.241 1.735a6.3 6.3 0 0 1 1.266 2.515c.226.921.241 1.88.043 2.807a6.3 6.3 0 0 1-1.187 2.552 6.45 6.45 0 0 1-2.187 1.802 6.56 6.56 0 0 1-5.563.167z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 33.28V18.002h9.042v14.692c0 4.113 2.258 5.875 5.958 5.875 3.493 0 5.96-1.763 5.96-5.876V18.002H39V33.28c0 5.093-2.673 12.733-15 12.733-12.122 0-15-7.64-15-12.733"
})));
export default SvgUnumLogoShortWhite;